// spec: https://www.figma.com/file/Tb6GgTuIDhCTiA132VuYT5/Ignite-Riddle?type=design&node-id=3895-2773&mode=design&t=xHuq1hFxTxwF41tK-0
export const Corner0 = "0px";
export const Corner2 = "2px";
export const Corner4 = "4px";
export const Corner6 = "6px";
export const Corner8 = "8px";
export const Corner10 = "10px";
export const Corner12 = "12px";
export const Corner16 = "16px";
export const Corner24 = "24px";
export const Corner48 = "48px";
export const Corner96 = "96px";

//# sourceMappingURL=corners.js.map